import styled from 'styled-components';

export const IconWrapper = styled.span.attrs({ 'aria-hidden': true })`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  padding: 6px;
  border: 2px solid var(--grey-200);
  border-radius: var(--radius-fullyrounded);
`;

export const LinksList = styled.ul`
  display: flex;
  gap: var(--spacing-base);
  list-style: none;
`;

export const LinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-base);
`;
